module.exports = __webpack_public_path__ + "static/img/ys1.afb7572.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ys1.png
// module id = l+26
// module chunks = 1